import styled from "styled-components";

import { colors, radii } from "shared/ui";

const COLUMNS = "72px minmax(140px, 1.2fr) minmax(160px, 1.6fr) minmax(110px, 0.9fr) 88px";
const NARROW = "767px";

export const List = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HeaderRow = styled.div`
    display: grid;
    grid-template-columns: ${COLUMNS};
    gap: 12px;
    align-items: center;
    padding: 0 4px 8px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${colors.textSecondary};

    @media (max-width: ${NARROW}) {
        display: none;
    }
`;

/*
* Одна разметка на оба вьюпорта: на узком строка раскладывается в блок
* (номер и действия сверху, остальные поля — подписанными строками ниже).
* */
export const Row = styled.div`
    display: grid;
    grid-template-columns: ${COLUMNS};
    gap: 12px;
    align-items: center;
    padding: 10px 4px;
    border-top: 1px solid ${colors.borderSofter};

    &:hover {
        background: ${colors.contentBg};
    }

    @media (max-width: ${NARROW}) {
        grid-template-columns: 1fr auto;
        grid-template-areas:
            "number actions"
            "title title"
            "description description"
            "external external";
        gap: 6px;
        padding: 14px 4px;
    }
`;

export const Cell = styled.div`
    min-width: 0;
    color: ${colors.textPrimary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: ${NARROW}) {
        display: flex;
        gap: 8px;
        white-space: normal;
    }
`;

export const NumberCell = styled(Cell)`
    @media (max-width: ${NARROW}) {
        grid-area: number;
    }
`;

export const TitleCell = styled(Cell)`
    font-weight: 600;

    @media (max-width: ${NARROW}) {
        grid-area: title;
    }
`;

export const DescriptionCell = styled(Cell)`
    color: ${colors.textSecondary};

    @media (max-width: ${NARROW}) {
        grid-area: description;
    }
`;

export const ExternalCell = styled(Cell)`
    color: ${colors.textSecondary};

    @media (max-width: ${NARROW}) {
        grid-area: external;
    }
`;

// Подпись поля нужна только в блочной раскладке — на широком её роль играет шапка таблицы.
export const CellLabel = styled.span`
    display: none;

    @media (max-width: ${NARROW}) {
        display: block;
        flex: 0 0 96px;
        font-size: 13px;
        color: ${colors.textSecondary};
    }
`;

export const CellValue = styled.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const NumberChip = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 28px;
    padding: 0 10px;
    border-radius: ${radii.chip};
    background: ${colors.segmentBg};
    font-weight: 700;
    color: ${colors.textPrimary};
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 4px;

    @media (max-width: ${NARROW}) {
        grid-area: actions;
    }
`;

export const IconButton = styled.button<{ $tone?: "neutral" | "danger" }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    border-radius: ${radii.small};
    background: transparent;
    cursor: pointer;
    color: ${({ $tone }) => ($tone === "danger" ? colors.danger : colors.textSecondary)};

    &:hover {
        background: ${({ $tone }) =>
            $tone === "danger" ? colors.dangerHover : colors.segmentBg};
    }

    &:focus-visible {
        outline: 2px solid ${colors.primary};
        outline-offset: 2px;
    }
`;
